import { render, staticRenderFns } from "./AccountName.vue?vue&type=template&id=0aff81f0&scoped=true"
import script from "./AccountName.vue?vue&type=script&lang=js"
export * from "./AccountName.vue?vue&type=script&lang=js"
import style0 from "./AccountName.vue?vue&type=style&index=0&id=0aff81f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aff81f0",
  null
  
)

export default component.exports